import * as actionTypes from '../actions/ActionTypes';
// import { goto_simulatedTest } from "../../../Navigation/actions";

const initialCommonState = {
  questionList: [],
  testTime: 190,
  // challengeSendData: [],
};

const SimulatedTestReducer = (state = initialCommonState, action) => {
  switch (action.type) {
    case actionTypes.GOTO_SIMULATED_TEST:
      return {
        ...state,
        questionBody: action.questionBody,
      };
    case actionTypes.LIST_OF_SIMULATED_QUESTIONS:
      return {
        ...state,
        questionList: action.questionArray,
        numberOfQuestionsList: action.numberOfQuestionsList,
        testTime: action.testTime,
      };
    case actionTypes.LOGOUT:
      return { ...initialCommonState };
    // case actionTypes.UPDATE_CHALLENGE_SEND_LIST:
    //   return {
    //     ...state,
    //     challengeSendData: action.data,
    //   };
    default:
      return state;
  }
};

export default SimulatedTestReducer;
